const TemisCivil = {
  //Documentos que pueden contener promociones
  TiposPormocion: 'TemisCivil/Catalogos/GetTiposPromocion',
  //Documentos sin relación
  TiposOtros: 'TemisCivil/Catalogos/GetTiposOtros',
  //Documentos que van a Mensajería
  TiposMensajeria: 'TemisCivil/Catalogos/GetTiposMensajeria',
  //Usuarios sistema Equitas
  UsuariosEquitas: 'TemisCivil/Catalogos/GetUsuariosEquitas',
  //Usuario sistema Digitalización
  UsuariosDigitalizacion: 'TemisCivil/Catalogos/GetUsuariosDigitalizacion',
  //Zonas de mensajería civil
  ZonasCiviles: 'TemisCivil/Catalogos/GetZonasCiviles',
  //Areas de EQUITAS con ordenamiento dinámico
  AreasRecepcion: 'TemisCivil/Catalogos/GetAreasRecepcion',
  //Documentos que se filtran para los reportes
  TiposDocumentoEnvio: 'TemisCivil/Catalogos/GetTiposDoc',
  //Areas de EQUITAS con ordenamiento dinámico
  AreasPromocion: 'TemisCivil/Catalogos/GetAreasPromocion',
  //Autoridades para las personalidades en materia de lo contencioso
  TiposInstitucion: 'TemisCivil/Catalogos/GetTiposInstitucion',
  //Autoridades para las personalidades en materia de lo contencioso
  Autoridades: 'TemisCivil/Catalogos/GetAutoridades',
  //Autoridades para las personalidades en materia de lo contencioso
  Cargos: 'TemisCivil/Catalogos/GetCargos',
  //Municipios para las instituciones en contencioso
  Municipios: 'TemisCivil/Catalogos/GetMunicipios',
};

export default TemisCivil;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/temiscivil/catalogos/temiscivil.js
// module id = null
// module chunks = 